import { create } from 'zustand';
import { persist, createJSONStorage } from 'zustand/middleware';
import React from 'react';

interface AppState {
    isAuthenticated: boolean;
    setAuthenticated: (status: boolean) => void;
    logout: () => void;
}

export const useStore = create<AppState>()(
    persist(
        (set) => ({
            isAuthenticated: false,
            setAuthenticated: (status) => set({ isAuthenticated: status }),
            logout: () => {
                set({ isAuthenticated: false });
                window.location.href = '/login';
                window.history.pushState("", "", "/");
                window.history.go(0);
            },
        }),
        {
            name: 'cribly-app-storage',
            storage: createJSONStorage(() => localStorage),
        }
    )
);

export const AppProvider = ({ children }: { children: React.ReactNode }) => {
    return <>{children}</>;
};